import './style.css';

const STORE = 'irradiation-schedule/settings-v1';
const weekdays = ['日', '月', '火', '水', '木', '金', '土'];
const defaultState = {
  startDate: '', sessions: 30, weekdays: [1, 2, 3, 4, 5],
  additions: [], exclusions: [], month: new Date().getMonth(), year: new Date().getFullYear()
};
let state = { ...defaultState, ...load() };

function load() { try { return JSON.parse(localStorage.getItem(STORE)) || {}; } catch { return {}; } }
function save() { localStorage.setItem(STORE, JSON.stringify(state)); }
function toKey(date) { return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`; }
function fromKey(key) { const [y, m, d] = key.split('-').map(Number); return new Date(y, m - 1, d); }
function dateLabel(key) { return `${fromKey(key).getMonth() + 1}/${fromKey(key).getDate()}（${weekdays[fromKey(key).getDay()]}）`; }
function has(list, key) { return list.includes(key); }
function isDefaultTreatment(key) { const date = fromKey(key); return state.weekdays.includes(date.getDay()); }
function isTreatment(key) { return (isDefaultTreatment(key) && !has(state.exclusions, key)) || has(state.additions, key); }
function plannedDates() {
  if (!state.startDate || !Number(state.sessions)) return [];
  const dates = []; let cursor = fromKey(state.startDate);
  for (let guard = 0; dates.length < Number(state.sessions) && guard < 3000; guard++, cursor.setDate(cursor.getDate() + 1)) {
    if (isTreatment(toKey(cursor))) dates.push(toKey(cursor));
  }
  return dates;
}
function escapeHtml(value) { const box = document.createElement('div'); box.textContent = value; return box.innerHTML; }

function render() {
  const dates = plannedDates();
  const end = dates.at(-1);
  const today = toKey(new Date());
  const monthStart = new Date(state.year, state.month, 1);
  const first = monthStart.getDay();
  const days = new Date(state.year, state.month + 1, 0).getDate();
  const cells = Array.from({ length: first + days }, (_, i) => {
    if (i < first) return '<div class="day empty"></div>';
    const key = toKey(new Date(state.year, state.month, i - first + 1));
    const number = dates.indexOf(key) + 1;
    const added = has(state.additions, key), excluded = has(state.exclusions, key);
    const cls = ['day', isTreatment(key) ? 'treatment' : '', added ? 'added' : '', excluded ? 'excluded' : '', key === today ? 'today' : ''].filter(Boolean).join(' ');
    return `<button class="${cls}" data-date="${key}" aria-label="${dateLabel(key)}">${i - first + 1}${number ? `<small>${number}回目</small>` : ''}${added ? '<i>追加</i>' : ''}${excluded ? '<i>休み</i>' : ''}</button>`;
  }).join('');
  document.querySelector('#app').innerHTML = `
    <main>
      <header><div><h1>照射スケジュール</h1><p>端末内に保存・オフラインでも確認できます</p></div><button id="install" class="outline" hidden>アプリを追加</button></header>
      <section class="summary ${end ? '' : 'muted'}">
        ${end ? `<strong>${state.sessions}回の予定</strong><span>最終予定日 <b>${dateLabel(end)}</b></span><span>開始日 ${dateLabel(state.startDate)}</span>` : '開始日と回数を設定してください'}
      </section>
      <section class="settings">
        <label>開始日<input id="startDate" type="date" value="${state.startDate}"></label>
        <label>照射回数<input id="sessions" type="number" min="1" max="365" value="${state.sessions}"></label>
        <fieldset><legend>通常の照射曜日</legend>${weekdays.map((day, index) => `<label class="weekday"><input type="checkbox" data-weekday="${index}" ${state.weekdays.includes(index) ? 'checked' : ''}>${day}</label>`).join('')}</fieldset>
      </section>
      <section class="calendar-card">
        <div class="calendar-head"><button id="previous" aria-label="前の月">‹</button><h2>${state.year}年${state.month + 1}月</h2><button id="next" aria-label="次の月">›</button></div>
        <div class="weekdays">${weekdays.map((d) => `<span>${d}</span>`).join('')}</div><div class="calendar">${cells}</div>
        <p class="hint">日付をタップすると照射日／休みを切り替えます。<span class="legend normal"></span>照射予定 <span class="legend addition"></span>休日に追加 <span class="legend off"></span>平日の休み</p>
      </section>
      <details><summary>設定の管理</summary><div class="manage"><button id="clear-exceptions" class="outline">例外設定をすべて消去</button><button id="reset" class="danger">すべて初期化</button></div></details>
      <footer>医療機関から案内された予定をご確認ください。</footer>
    </main>`;
  bind();
}
function update(patch) { Object.assign(state, patch); save(); render(); }
function toggleDate(key) {
  const normal = isDefaultTreatment(key);
  if (normal) state.exclusions = has(state.exclusions, key) ? state.exclusions.filter((d) => d !== key) : [...state.exclusions, key];
  else state.additions = has(state.additions, key) ? state.additions.filter((d) => d !== key) : [...state.additions, key];
  save(); render();
}
function bind() {
  document.querySelector('#startDate').addEventListener('change', (e) => update({ startDate: e.target.value }));
  document.querySelector('#sessions').addEventListener('change', (e) => update({ sessions: Math.max(1, Math.min(365, Number(e.target.value) || 1)) }));
  document.querySelectorAll('[data-weekday]').forEach((box) => box.addEventListener('change', () => {
    state.weekdays = [...document.querySelectorAll('[data-weekday]:checked')].map((item) => Number(item.dataset.weekday)); save(); render();
  }));
  document.querySelectorAll('[data-date]').forEach((button) => button.addEventListener('click', () => toggleDate(button.dataset.date)));
  document.querySelector('#previous').addEventListener('click', () => { const d = new Date(state.year, state.month - 1, 1); update({ year: d.getFullYear(), month: d.getMonth() }); });
  document.querySelector('#next').addEventListener('click', () => { const d = new Date(state.year, state.month + 1, 1); update({ year: d.getFullYear(), month: d.getMonth() }); });
  document.querySelector('#clear-exceptions').addEventListener('click', () => update({ additions: [], exclusions: [] }));
  document.querySelector('#reset').addEventListener('click', () => { if (confirm('開始日・回数・例外設定をすべて初期化しますか？')) { state = { ...defaultState, year: state.year, month: state.month }; save(); render(); } });
}

let installEvent;
window.addEventListener('beforeinstallprompt', (event) => { event.preventDefault(); installEvent = event; const button = document.querySelector('#install'); button.hidden = false; button.onclick = async () => { await installEvent.prompt(); button.hidden = true; }; });
if ('serviceWorker' in navigator) window.addEventListener('load', () => navigator.serviceWorker.register('./sw.js'));
render();
